import React from 'react';

export const StepNavigator = ({
    steps,
    currentStep,
    goNext,
    goBack,
    resetSteps,
    handleSetCurrentIndex,
    currentIndex,
    handleEditClick,
    setFocusedConversionId,
}) => {
    const currentStepData = steps[currentStep];

    return (
        <div>
            {React.cloneElement(currentStepData.content, {
                goNext,
                goBack,
                resetSteps,
                handleSetCurrentIndex,
                currentIndex,
                handleEditClick,
                setFocusedConversionId,
            })}
        </div>
    );
};
